import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import registerImage from '../../../assets/images/register-image.jpg'
import Image from '../../atoms/Image/Image'
import { Link } from 'react-router'
import FormRegister from '../../molecules/Form/FormRegister'
const Register = () => {
    
    return (
        <>
            <section className="login-form section-padding">
                <Container>
                    <Row className='g-0 align-items-center justify-content-center'>
                        <Col className='col-12 col-md-10 p-0 login-form--item'>
                            <Row className='g-0 align-items-center justify-content-center'>
                                <Col className='col-12 col-lg-6'>
                                    <div className='login-form--item-left'>
                                        <h1 className='h1'>Personal Information</h1>
                                        <p className='mb-0'>To get started, tell us about yourself.</p>
                                        <FormRegister />
                                        
                                        
                                    </div>
                                </Col>
                                <Col className='col-12 col-lg-6'>
                                    <figure className="mb-0 login-form--item--image">
                                        <Image src={registerImage} alt="" height="1000" width="900" />
                                    </figure>
                                </Col>
                            </Row>
                        </Col> 
                    </Row>
                    <Row className='justify-content-center mt-5'>
                        <Col className='col-12 col-md-10 text-center '>
                            <h5 className='mb-0 h5 '>Do you already have a account? <Link to="/login">Login</Link> </h5>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Register
